import { render } from "./ScenicTour.vue?vue&type=template&id=f23aa996&scoped=true"
import script from "./ScenicTour.vue?vue&type=script&lang=js"
export * from "./ScenicTour.vue?vue&type=script&lang=js"

import "./ScenicTour.vue?vue&type=style&index=0&id=f23aa996&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f23aa996"]])

export default __exports__